document.querySelectorAll('.product__thumb-item a').forEach(thumb => {
    thumb.addEventListener('click', () => {
        document.querySelector('.variant-input .variant__button-label[data-media-id="' + thumb.getAttribute('data-id') + '"]').click()
    });
});

// Start tabs.js
(function() {

  'use strict';

  var tabs = function(options) {

    var el = document.querySelector(options.el);
    var tabNavigationLinks = el.querySelectorAll(options.tabNavigationLinks);
    var tabContentContainers = el.querySelectorAll(options.tabContentContainers);
    var activeIndex = 0;
    var initCalled = false;

    var init = function() {
      if (!initCalled) {
        initCalled = true;
        el.classList.remove('no-js');
        
        for (var i = 0; i < tabNavigationLinks.length; i++) {
          var link = tabNavigationLinks[i];
          handleClick(link, i);
        }
      }
    };

    var handleClick = function(link, index) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        goToTab(index);
      });
    };

    var goToTab = function(index) {
      if (index !== activeIndex && index >= 0 && index <= tabNavigationLinks.length) {
        tabNavigationLinks[activeIndex].classList.remove('is-active');
        tabNavigationLinks[index].classList.add('is-active');
        tabContentContainers[activeIndex].classList.remove('is-active');
        tabContentContainers[index].classList.add('is-active');
        activeIndex = index;
      }
    };

    return {
      init: init,
      goToTab: goToTab
    };

  };

  window.tabs = tabs;

})();
// End tabs.js


if(document.querySelector('#tabs1')) {
    var myTabs1 = tabs({
      el: '#tabs1',
      tabNavigationLinks: '.tab-link',
      tabContentContainers: '.tab-content'
    });


    myTabs1.init();
}




/*=============== ACCORDION ===============*/
const accordionContainers = document.querySelectorAll('.accordion__container')

accordionContainers.forEach((container) => {

    const items = container.querySelectorAll('.accordion__item');

    items.forEach((item) => {

        const accordionHeader = item.querySelector('.accordion__header')
        const accordionContent = item.querySelector('.accordion__content')
        if(item.classList.contains('accordion-open')){
            accordionContent.style.height = accordionContent.scrollHeight + 'px'
        }


        accordionHeader.addEventListener('click', () =>{
            const openItem = container.querySelector('.accordion-open')

            toggleItem(item);

            if(openItem && openItem !== item){
                toggleItem(openItem);
            }
        });

    });

});

window.addEventListener('resize', () => {

    accordionContainers.forEach((container) => {

        const items = container.querySelectorAll('.accordion__item');

        items.forEach((item) => {

            const accordionContent = item.querySelector('.accordion__content')
            if(item.classList.contains('accordion-open')){
                if(accordionContent.scrollHeight > parseInt(accordionContent.style.height)) {
                    accordionContent.style.height = accordionContent.scrollHeight + 'px'
                } else if (item.querySelector('.accordion__description').clientHeight + 15 < parseInt(accordionContent.style.height)) {
                    accordionContent.style.height = (item.querySelector('.accordion__description').clientHeight + 15) + 'px'
                }

            }

        });

    });

});

const toggleItem = (item) => {

    const accordionContent = item.querySelector('.accordion__content')
    if(item.classList.contains('accordion-open')){
        accordionContent.removeAttribute('style')
        item.classList.remove('accordion-open')
    } else {
        accordionContent.style.height = accordionContent.scrollHeight + 'px'
        item.classList.add('accordion-open')
    }
}


function openVideo() {
   var element = document.getElementById("VideoModal");
   element.classList.toggle("active");
}

/*=============== CHAT WIDGET: MOVE OUT OF THE WAY WHEN CART DRAWER OPENS ===============*/
(function() {
  var cartDrawer = document.getElementById('CartDrawer');
  if (!cartDrawer) return;

  function showChatAway() {
    document.body.classList.add('cart-drawer-open');
  }
  function showChatBack() {
    document.body.classList.remove('cart-drawer-open');
  }

  // Primary signal: clicking the cart icon anywhere on the page opens the drawer
  document.addEventListener('click', function(e) {
    if (e.target.closest('.js-drawer-open-cart')) {
      setTimeout(showChatAway, 50);
    }
    if (e.target.closest('.js-drawer-close') || e.target.closest('.drawer__close-button')) {
      setTimeout(showChatBack, 50);
    }
  });

  // Backup signal: watch class/style changes directly on the drawer element
  function syncFromDrawerState() {
    var cls = cartDrawer.className || '';
    var looksOpen = /\b(is-active|is-open|active|open)\b/.test(cls);
    if (looksOpen) {
      showChatAway();
    } else {
      showChatBack();
    }
  }

  var cartDrawerObserver = new MutationObserver(syncFromDrawerState);
  cartDrawerObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class', 'style'] });

  // Also treat Escape key as a close signal (common pattern for drawers)
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      setTimeout(showChatBack, 50);
    }
  });
})();
